import { create } from "zustand/react";
import ContractSortTypeEnum from "@/constants/enums/ContractSortTypeEnum";
import { OrderStatus } from "@/types";
import OrderStatusEnum from "@/constants/enums/OrderStatusEnum";

type OrderState = {
  currentPage: number;
  numberOfPages: number;
  limit: number;
  sortDirection: "ASC" | "DESC";
  setSortDirection: (sortDirection: "ASC" | "DESC") => void;
  setPage: (page: number) => void;
  setNumberOfPages: (numberOfPages: number) => void;
  setLimit: (limit: number) => void;
  statuses: OrderStatus[];
  setStatuses: (statuses: OrderStatus[]) => void;
  orderTypes: number[] | null;
  setOrderTypes: (orderTypes: number[] | null) => void;
  onlyPromoted: boolean;
  setOnlyPromoted: (onlyPromoted: boolean) => void;
  awaitingProccessingOnly: boolean;
  setAwaitingProccessingOnly: (awaitingProccessingOnly: boolean) => void;
  salesItemId: number | null;
  setSalesItemId: (salesItemId: number | null) => void;
  sortBy: string;
  setSortBy: (sortBy: string) => void;
  includeInactive: boolean;
  setIncludeInactive: (includeInactive: boolean) => void;
  excludeContractOrders: boolean;
  setExcludeContractOrders: (excludeContractOrders: boolean) => void;
  reset: () => void;
};

export const useOrderStore = create<OrderState>((set) => ({
  currentPage: 1,
  numberOfPages: 0,
  limit: 15,
  sortOption: ContractSortTypeEnum.BY_DATE,
  sortDirection: "DESC",
  setSortDirection: (sortDirection: "ASC" | "DESC") => set({ sortDirection }),
  setPage: (page) => set({ currentPage: page }),
  setNumberOfPages: (numberOfPages) => set({ numberOfPages }),
  setLimit: (limit) => set({ limit }),
  statuses: [OrderStatusEnum.ACTIVE],
  setStatuses: (statuses: OrderStatus[]) => set({ statuses }),
  orderTypes: null,
  setOrderTypes: (orderTypes: number[] | null) => set({ orderTypes }),
  onlyPromoted: false,
  setOnlyPromoted: (onlyPromoted: boolean) => set({ onlyPromoted }),
  awaitingProccessingOnly: false,
  setAwaitingProccessingOnly: (awaitingProccessingOnly: boolean) => set({ awaitingProccessingOnly }),
  salesItemId: null,
  setSalesItemId: (salesItemId: number | null) => set({ salesItemId }),
  sortBy: "date",
  setSortBy: (sortBy: string) => set({ sortBy }),
  includeInactive: false,
  setIncludeInactive: (includeInactive: boolean) => set({ includeInactive }),
  excludeContractOrders: false,
  setExcludeContractOrders: (excludeContractOrders: boolean) => set({ excludeContractOrders }),
  reset: () =>
    set({
      currentPage: 1,
      // numberOfPages: 0,
      limit: 15,
    }),
}));
